// extracted by mini-css-extract-plugin
module.exports = {"container":"buttons-checkbox-container","check":"buttons-checkbox-check","input":"buttons-checkbox-input","label":"buttons-checkbox-label"};